import { Model } from "./model";
import React from "react";
import { useConfigurator } from "./context/context";
import { useEffect } from "react";
import { LoopOnce } from "three";
import { state } from "./store";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

export function RenderModel() {
    const navigate = useNavigate()
    const modelRef = useRef()
    const group = modelRef.current?.group.current;
    const boxRef = modelRef.current?.boxRef.current;

    const {
        g_actions, g_animations, g_mixer,g_materials, clickedMesh
    } = useConfigurator()

    
    const onHover=(e)=>{
       
        if (e.intersections[0].object.parent==boxRef) {
            document.body.style.cursor = 'pointer' 
        }
    }

    const onHoverOut=(e)=>{
        document.body.style.cursor = 'default' 
    }

    function onClickEvent(e) {    
  
        let mesh = e.object
        let id = mesh.name.slice(-1);

        window._satellite.track('digitalcatalog', {
            'event': 'click_select_flavour',
            'eventLabel': id,
        });
        
        console.log("event: click_select_flavour", id)
        redirect(id)
    }

    function redirect(id) {
        document.body.style.cursor = 'default'
        navigate(state.links[id])
    }

    //general lights from environment map

    function adjustEnv(mats) {
        Object.values(mats).forEach(mat => {
            let chocolatini = Object.values(mats)[0];
            let piano = Object.values(mats)[1];
            
            chocolatini.roughness = 0.75;
            chocolatini.envMapIntensity = 0.65;
            piano.envMapIntensity = 1;

            //console.log("chocolatini.params", chocolatini)
            //console.log("chocolatini.roughness", chocolatini.roughness)
            //mat.envMapIntensity=0.5 //default value
            //mat.envMapIntensity=0.2
            //debugger
        })
    }

    //all light, for every one: model.jsx

    function adjustLights(scene) {       
        scene.traverse(obj=>{
            const regex = /\b\w*Light\b/;
            if (regex.test(obj.type)) {
              obj.intensity=0.1
            }
        })
    }
  
    function setPlay() {
        group.visible = true
        if (state.startTimeout>0) {
            setTimeout(() => {                
                g_mixer.clipAction(g_animations[0]).play()
                g_mixer.clipAction(g_animations[1]).play()
            }, state.startTimeout);
        return
        }    
        g_mixer.clipAction(g_animations[0]).play()
        g_mixer.clipAction(g_animations[1]).play()
    }

    function setPaused() {
        const duration = g_animations[0].duration
        g_mixer.clipAction(g_animations[1]).play()
        g_mixer.clipAction(g_animations[0]).play()
        g_mixer.setTime(duration)
        g_mixer.clipAction(g_animations[0]).paused = true
        g_mixer.clipAction(g_animations[1]).paused = true
        g_mixer.update()
        group.visible = true
        state.boxOpen = true
    }

    let playAnims = () => {     
        Object.keys(g_actions).forEach(element => {
            let action = g_actions[element]
            action.setLoop(LoopOnce)
            action.clampWhenFinished = true

        });

        if (state.firstRender) {
            setPlay()
            state.firstRender = false
            return
        }
        if (!state.replayAnim && !state.firstRender) { setPaused(); return }

        setPlay()
    }


    if (clickedMesh) {
        onClickEvent(clickedMesh)
    }

    useEffect(() => {
        if (g_materials) { 
            
        adjustEnv(g_materials)

        adjustLights(group.parent)
    }
   

    }, [g_materials])

    useEffect(() => {
        if (g_actions) {          

            g_mixer.addEventListener('finished', () => {
                if (!state.boxOpen) { state.boxOpen = true }
            })       

            playAnims()

        }
    }, [g_actions])


    return (
        <Model ref={modelRef} passedFunctions={{onHover,onHoverOut}} />
    )

}